<div class="app_ui_splash_logo" style="padding-left:10px;padding-right:10px;">
  <img [src]="cap_image" alt="">
</div>
